import { req } from "@/axios/http";
/**
 * 烟草总分
 * @param licenseCode 许可证号
 * @returns any
 */
export function getSchoolList(params: any): Promise<any> {
  return req.get({
    url: "/admin/rabbit/merchant/school/page",
    params,
  });
}
